import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="file--validate-file-extension-filter-list"
export default class extends Controller {
  static targets = ["input", "submitButton", "errorMessage"];

  connect() {
    this.inputTarget.addEventListener("input", this.validateInput);
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.validateInput);
  }

  // Arrow class field: stable reference so removeEventListener matches the one
  // added in connect(), and `this` stays bound to the controller.
  validateInput = () => {
    const value = this.inputTarget.value.trim();

    if (!value) {
      this.setValid();
      return;
    }

    const extensions = value.split(",").map((ext) => ext.trim());
    const isValid = extensions.every((ext) => /^[a-zA-Z0-9]+$/.test(ext));

    if (isValid) {
      this.setValid();
    } else {
      this.setInvalid();
    }
  };

  setValid() {
    this.submitButtonTarget.disabled = false;
    this.errorMessageTarget.classList.add("hidden");
    this.inputTarget.classList.remove("is-invalid");
  }

  setInvalid() {
    this.submitButtonTarget.disabled = true;
    this.errorMessageTarget.classList.remove("hidden");
    this.inputTarget.classList.add("is-invalid");
  }
}
